export default {
    require: function() {
        return {validate: (val) => !!val, message: 'Required'}
    },
    eqLength: function(length) {
        return {validate: (val) => val.length == length, message: 'Length must be equal to' + length }
    },
    minLength: function(length) {
        return {validate: (val) => val.length >= length, message: 'Length must be less than' + length }
    },
    maxLength: function(length) {
        return {validate: (val) => val.length <= length, message: 'Length must be more than' + length }
    },
    validateAccount: function(){
        return {
            validate:(value) => /^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]+$/.test(value), 
            message: "Invalid format"
         }
     },
    phoneNumber: function(){
         return {
             validate: value=> (((/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/)) | (/^((0\d{2,3}-\d{7,8})|(1[3567894]\d{9}))$/) .test(value)),
             message: "Invalid format"
         }
    },
    minValue: function(minVal) {
        return {validate: (val) => minVal? val >= minVal : true, message: 'Not less than' + minVal}
    },
    maxValue: function(maxVal) {
        return {validate: (val) => val <= maxVal, message: 'Cannot be greater than于' + maxVal}
    },
    email: function(){
        return{
            // validate: val => /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g.test(val),
            // message: "Invalid format"
          validate: val =>/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(val),
          message: "Invalid format"
        }
    },
    idcard: function(){
        return{
          validate: (val) => /^\d{18}|[0-9x]{18}|[0-9X]{18}?$/.test(val),
          message: "Incorrect ID card number"
        }
    },
    digital: function() {
        return{
            validate: (val) => /^\d+.?\d{0,99}$/.test(val),
            message: "Only numbers are allowed"
          }
    }
}



// WEBPACK FOOTER //
// ./src/utils/validateEn.js